(() => {
 const refine = () => {
  const checkout = document.querySelector('.cart__input-buttons [name="checkout"]');
  document.querySelectorAll('.bacurrcheckoutNotice').forEach(notice => {
   if (/At checkout, your currency will convert back/i.test(notice.textContent)) notice.textContent = 'Checkout is charged in Kuwaiti dinars (KWD).';
   if (checkout) {
    notice.classList.add('ms-currency-checkout-note');
    if (notice.parentElement !== checkout.parentElement) checkout.before(notice);
   }
  });
 };
 refine();
 new MutationObserver(refine).observe(document.body, {childList:true,subtree:true,characterData:true});
})();
